import React, { ReactNode, useState } from 'react'
import SearchBox from '../SearchBox'
import clsx from 'clsx'
import ListItem from './ListItem'
import useShowMore from 'modules/common/hooks/useShowMore'

type itemsPropType = {
  label: ReactNode
  value?: any
  items?: (...args: { [p: string]: any }[]) => void
}[]

type PropsType = {
  cx: (val1: string, val2: any) => string | undefined
  renderItem: (item: any, resetQuery: any) => ReactNode
  // Only required with showMore.
  translate?: (key: string, ...params: any[]) => string
  items: itemsPropType
  selectItem?: (item: any, resetQuery: any) => void
  className?: string
  showMore: boolean
  limit: number
  showMoreLimit: number
  show?: () => void
  searchForItems?: (val: any) => void
  searchable?: boolean
  isFromSearch?: boolean
  canRefine?: boolean
}

const List = (props: PropsType) => {
  /************************
   * PROPS
   *************************/
  const {
    limit,
    showMoreLimit,
    renderItem: renderComponent,
    cx,
    items,
    searchable,
    canRefine,
    showMore,
    translate,
    searchForItems,
    isFromSearch,
    selectItem,
  } = props

  /************************
   * STATE
   *************************/
  const [query, setQuery] = useState('')
  const { showMoreProps, ShowMore, visibleItems } = useShowMore({
    showMore,
    limit,
    showMoreLimit,
    items,
  })

  const resetQuery = () => setQuery('')

  /*****************************
   * render
   ******************************/

  const renderSearchBox = () => {
    const noResults =
      !items || (items?.length === 0 && query !== '') ? (
        <div className={clsx('noResults')}>
          <>{translate && translate('noResults')}</>
        </div>
      ) : null
    return (
      <div className={clsx('searchBox')}>
        <SearchBox
          currentRefinement={query}
          refine={(value) => {
            setQuery(value)
            searchForItems && searchForItems(value)
          }}
          // @ts-ignore
          focusShortcuts={[]}
          translate={translate}
          onSubmit={(e: React.FormEvent) => {
            e.preventDefault()
            e.stopPropagation()
            if (isFromSearch && selectItem) {
              selectItem(items[0], resetQuery)
            }
          }}
        />
        {noResults}
      </div>
    )
  }

  const searchBox = searchable ? renderSearchBox() : null

  if (!items || items.length === 0) {
    return <div>{searchBox}</div>
  }

  return (
    <div>
      {searchBox}
      <ul className={cx('list', !canRefine && 'list--noRefinement')}>
        {visibleItems.map((item: any) => (
          <ListItem
            key={item.key || item.label}
            item={item}
            resetQuery={resetQuery}
            renderComponent={renderComponent}
          />
        ))}
        <ShowMore key="showMore" {...showMoreProps} />
      </ul>
    </div>
  )
}

List.defaultProps = {
  className: '',
  isFromSearch: false,
  limit: 10,
}
export default List
